import { cva } from 'class-variance-authority';
import type { HTMLAttributes } from 'react';
import { cn } from './cn';

/**
 * DESIGN.md › tab-bar on the web: the white pill that sits
 * at the top of the 800px column, one destination per equal share — an illustration over a
 * short label, the active one on teal with a white label. Presentation only: the app renders
 * its router's links with `pillTabBarItem` and keeps the translated labels.
 */
export function PillTabBar({ className, ...props }: HTMLAttributes<HTMLElement>) {
  return (
    <nav
      className={cn('flex w-full rounded-full bg-surface p-internal-sm shadow-task-row', className)}
      {...props}
    />
  );
}

/** Class names for one destination; `active` is the teal state. */
export const pillTabBarItem = cva(
  'flex min-h-[88px] min-w-0 flex-1 flex-col items-center justify-center gap-internal-sm rounded-full p-internal-lg px-internal-sm font-brand text-body-xs font-bold transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-border-highlight sm:px-internal-lg',
  {
    variants: {
      active: {
        true: 'bg-tab-bar-active text-on-tab-bar shadow-task-row',
        false: 'text-on-tab-bar-inactive hover:bg-surface-secondary',
      },
    },
    defaultVariants: { active: false },
  },
);
